import React, { Component } from "react";

import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
//import { Document, Page, pdfjs } from 'react-pdf';

class QuotationForm extends Component {

	componentDidMount() {
		this.acceptQuotation = this.acceptQuotation.bind(this);
//		pdfjs.GlobalWorkerOptions.workerSrc = "/js/pdf.worker.js";
	}
	
	acceptQuotation() {
		this.props.acceptQuotation();
	}
	
	render() {
		var accept;
			if(this.props.state=="quotation_pending"){
				accept = <Icon style={{ fontFamily: "tipoecl", fontSize: "36px", color: "#15c600", cursor: "pointer"}}  onClick={() => { this.acceptQuotation(); }}>&#59413;</Icon>
			}else{
				accept=<Grid item>Quotation accepted</Grid>
			}
			return (<div></div>);
/*		return (
			
			<div class="contentM">
				<h1 className="title">Accept Quotation {this.props.code}</h1>
				<Grid container item direction="row" alignItems="flex-start" justify="center">
					<Grid item xs={3}>
						<Grid container item direction="row" alignItems="center" justify="center" xs={12} >
							<Grid item xs={2}><a target="_blank"  href={process.env.REACT_APP_serverURL+"/documents-0.0.1/project/"+this.props.quotationId+"/quotation/pdf?access_token="+this.props.accessToken} target="_blank"><Icon style={{ fontFamily: "tipoecl", fontSize: "26px"}}>&#59408;</Icon></a></Grid>
							<Grid item xs={2}>{accept}</Grid>
						</Grid>
					</Grid>
					<Grid item xs={9}>
						<Document
							object-fit="fill"
							size="A4"
							file={{
								url: process.env.REACT_APP_serverURL+"/documents-0.0.1/project/"+this.props.quotationId+"/quotation/pdf?access_token="+this.props.accessToken
							}}>
							<Page pageNumber={1}/>
						</Document>
					</Grid>
				</Grid>
			</div>
		)*/
	}
}

export default QuotationForm;